import { render, staticRenderFns } from "./22qidongye.vue?vue&type=template&id=23b11313&scoped=true&"
import script from "./22qidongye.vue?vue&type=script&lang=js&"
export * from "./22qidongye.vue?vue&type=script&lang=js&"
import style0 from "./22qidongye.vue?vue&type=style&index=0&id=23b11313&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b11313",
  null
  
)

export default component.exports